/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Toast_Pos_Delivery_CreatedInputs */

const vi_toast_pos_delivery_created = /** @type {(inputs: Toast_Pos_Delivery_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tạo đơn giao ${i?.code}`)
};

/**

* @param {Toast_Pos_Delivery_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_pos_delivery_created = /** @type {((inputs: Toast_Pos_Delivery_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Pos_Delivery_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_pos_delivery_created(inputs)
});